<template functional>
  <SocialImage
    title="Google meu negócio"
    v-bind="data.attrs"
    :class="[data.class, data.staticClass]"
    channel="googlemybusiness"
    v-on="listeners"
  />
</template>

<script>
import SocialImage from './SocialImage';

export default {
  name: 'GoogleMyBusinessImage',
  components: {
    SocialImage,
  },
};
</script>
